module.exports = __webpack_public_path__ + "static/media/Tooth_icon_009aee.4e04e841.svg";